module.exports = __webpack_public_path__ + "8a9230b8075ba6429c2a0c0c8299ceb9.png";